// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"500":"42851b5c","952":"491f0714"}[chunkId] + ".chunk.js";
};